module.exports = __webpack_public_path__ + "img/table_reserved.0c52db26.png";